var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-app',{staticStyle:{"height":"100%","overflow":"hidden"}},[_c('dialog-listener'),_c('action-service'),_c('start-application',{attrs:{"route":_vm.currentRoute,"query":_vm.queryString,"path":_vm.pathname},on:{"start-application-created":_vm.createServices}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }